import { ProductGtmEvents } from '@/gtm/product/product-gtm-events';

export class ProductRecentlyViewedGtmEvents extends ProductGtmEvents {
  scrollProducts() {
    return this.gtmEvent({
      eventAction: 'Карточка_Просмотренное_Скрол',
    });
  }

  openQuickView({ productCode }) {
    return this.gtmEvent({
      eventAction: 'Карточка_Просмотренное_БП',
      eventLabel: productCode,
    });
  }

  clickProduct({ productCode }) {
    return this.gtmEvent({
      eventAction: 'Карточка_Просмотренное_Клик',
      eventLabel: productCode,
    });
  }

  chooseSize({ productCode }) {
    return this.gtmEvent({
      eventAction: 'Карточка_Просмотренное_Размер',
      eventLabel: productCode,
    });
  }

  chooseColor({ productCode }) {
    return this.gtmEvent({
      eventAction: 'Карточка_Просмотренное_Цвет',
      eventLabel: productCode,
    });
  }

  addToFavorite({ productCode }) {
    return this.gtmEvent({
      eventAction: 'Карточка_Просмотренное_ДобавитьВИзбранное',
      eventLabel: productCode,
    });
  }

  removeFromFavorite({ productCode }) {
    return this.gtmEvent({
      eventAction: 'Карточка_Просмотренное_УдалитьИзИзбранного',
      eventLabel: productCode,
    });
  }

  toggleFavorite({ value, productCode }) {
    return value
      ? this.addToFavorite({ productCode })
      : this.removeFromFavorite({ productCode });
  }
}
